module.exports = __webpack_public_path__ + "media/images/card-dinersclub-ed133560e1d119a7dee2a36c13a3ebc3.svg";